import React from 'react';
import ActivityIndicator from '../../ActivityIndicator';
import {
  Box,
  Grid,
  Paper,
  Tooltip,
  Typography,
  makeStyles,
} from '@material-ui/core';
import { Link } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(2),
    backgroundColor: '#fff',
    border: '2px solid #fff',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
  },
  title: {
    fontFamily: 'Quicksand, sans-serif',
    fontSize: '1.7rem',
    color: '#1c2434',
    fontWeight: 600,
  },
  header: {
    marginBottom: '1rem',
    textAlign: 'left',
  },

  container: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    marginBottom: '0.2rem',
  },
  text: {
    fontFamily: 'Quicksand, sans-serif',
    fontWeight: 500,
    fontSize: '1rem',
    lineHeight: '1rem',
    color: '#1c2434',

    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  paragraph: {
    fontFamily: 'Quicksand, sans-serif',
    fontWeight: 500,
    color: '#1c2434',
    fontSize: '1rem',
    lineHeight: '1rem',
    textAlign: 'center',
  },
  progressContainer: {
    position: 'relative',
    marginRight: theme.spacing(1),
    backgroundColor: '#eff4fb',
    height: '40px',
    borderRadius: '0px 4px 4px 0px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  link: {
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    color: '#1c2434',
    fontWeight: 500,
    textDecoration: 'none',
    fontSize: '1rem',

    '&:focus, &:active, &:hover': {
      textDecoration: 'none',
      color: 'rgba(255, 69, 0)',
    },
  },
}));

interface Props {
  data: any;
  loading: boolean;
}

const TableCardFreight: React.FC<Props> = ({ data, loading }) => {
  const classes = useStyles();

  if (loading) {
    return <ActivityIndicator />;
  }

  return (
    <Paper className={classes.root}>
      <Typography className={classes.title} variant="h6" gutterBottom>
        Tempo de Aceitação
      </Typography>
      <Grid container spacing={1} className={classes.header}>
        <Grid item xs={4}>
          <Tooltip title={'Distribuidora responsavel'}>
            <Typography
              variant="subtitle1"
              className={classes.text}
              style={{ color: '#64748B', marginLeft: '8px' }}
            >
              Distribuidora
            </Typography>
          </Tooltip>
        </Grid>
        <Grid item xs={5}>
          <Typography
            variant="subtitle1"
            className={classes.paragraph}
            style={{ color: '#64748B' }}
          >
            Tempo de aceitação
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography
            variant="subtitle1"
            className={classes.paragraph}
            style={{ color: '#64748B' }}
          >
            Peso
          </Typography>
        </Grid>
      </Grid>
      {data.map((freights: any, index: number) => (
        <Grid container spacing={1} className={classes.container} key={index}>
          <Grid item xs={6}>
            <Box className={classes.progressContainer}>
              <Tooltip title={freights.distributor}>
                <Typography
                  className={classes.text}
                  style={{ marginLeft: '8px' }}
                >
                  {freights.distributor}
                </Typography>
              </Tooltip>
            </Box>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body1" className={classes.paragraph}>
              {Math.floor(freights.waitingtime)} Horas
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body1" className={classes.paragraph}>
              {freights.totalweight} Kg
            </Typography>
          </Grid>
        </Grid>
      ))}
      <Link className={classes.link} to="/home/shippings">
        Ver mais
      </Link>
    </Paper>
  );
};

export default TableCardFreight;
